import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { IPaymentNotificationItem, IPaymentNotificationsActions, IPaymentNotificationsState } from './state.types'
import { getPaymentNotificationsList } from './api'
import { createLatestRequestController } from '../latest-request'


export const initialStatePaymentNotifications: IPaymentNotificationsState = {
    error: null,
    notifications: {
        isLoading: false,
        items: [] as IPaymentNotificationItem[],
        totalCount: 0,
        pageSize: 0,
        currentPage: 0,
    },
}

const paymentNotificationsListRequest = createLatestRequestController()

/** Хранилище страницы - Извещения о платежах */
export const usePaymentNotifications = create<IPaymentNotificationsState & IPaymentNotificationsActions>()(devtools((set) => ({
    ...initialStatePaymentNotifications,

    /** Сброс хранилища до начального состояния. */
    clearPaymentNotificationsState: () => {
        paymentNotificationsListRequest.invalidate()
        set(initialStatePaymentNotifications)
    },

    /** Запрос на получение основного списка извещений. */
    actionGetPaymentNotificationsList: async (pageNumber: number, search: string) => {
        const request = paymentNotificationsListRequest.start()
        set((state) => ({ notifications: { ...state.notifications, isLoading: true } }))

        const res = await getPaymentNotificationsList(pageNumber, search, request.signal)
        if (!request.isCurrent()) return
        request.finish()

        if (res.status !== 200) set({ error: { type: res.status === 500 ? 'error' : 'warning', message: res.message } })

        if (res.message === 'OK') {
            set({ error: null })
            set((state) => ({
                notifications: {
                    ...state.notifications,
                    items: res.data!.items,
                    totalCount: res.data!.totalCount,
                    pageSize: res.data!.pageSize,
                    currentPage: res.data!.currentPage,
                },
            }))
        }

        set((state) => ({ notifications: { ...state.notifications, isLoading: false } }))
    },
})))